import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const JobOfferApplicationsStyled = styled.div`
  /* Mismo padding que el resto de páginas (candidatos, favoritos, ficha) */
  && {
    padding: 30px 60px;
  }

  .containerHeader {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    max-width: 100%;
    /* Sin card blanca ni padding propio: el padding lo pone la raíz de la página */
    padding: 0;
    gap: 50px;
  }

  .sectionSecond {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 16px;

    > button {
      flex-shrink: 0;
    }

    label {
      font-weight: 500;
      font-size: 14px;
      margin-bottom: 0px;
      margin-right: 20px;
    }
    input {
      font-size: 14px;
      font-family: 'Poppins';
    }

    & h2 {
      font-size: 20px; /* título de página de Velora, igual que candidatos y favoritos */
      font-weight: 600;
      line-height: 1.2;
      color: ${tokens.color.text.primary};
      margin-bottom: 0;
    }
    & h5 {
      font-size: 14px;
      font-weight: 400;
      color: ${tokens.color.text.tertiary};
      line-height: inherit;
    }

    & p {
      font-weight: 400;
      color: #7a808d;
    }
  }

    .MuiTableHead-root th:nth-child(n+2) {
        text-align: left !important;
    }

    .MuiTableHead-root th:nth-child(n+9) {
      text-align: center !important;
  }
    
  /* Filtros aplicados a la izquierda; botón de filtrar a la derecha */
  .applications-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 16px;

    .applications-filters,
    .applications-actions {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 16px;
    }
  }

  /* Resumen de filtros aplicados (react-select de solo lectura) */
  .selectContainer {
    min-width: 240px;
    max-width: 400px;
  }
    
  .avatarField {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
      
    .createdAt {
        margin-top: 5px;
        font-size: 12px;
        font-weight: 500;
        line-height: 18px;
        text-align: start;
    }
      
    .avatarFieldSubgroup {
        display: flex;
        justify-content: space-between;
    }
  }
    
  .read {
      font-weight: 400;
  }
  
  /* No leídas en 600, como la bandeja de candidatos */
  .not-read {
      font-weight: 600;
  }
`

export default JobOfferApplicationsStyled
